import { render, staticRenderFns } from "./langhamAuthed.vue?vue&type=template&id=2c6a1d69&scoped=true&"
import script from "./langhamAuthed.vue?vue&type=script&lang=js&"
export * from "./langhamAuthed.vue?vue&type=script&lang=js&"
import style0 from "./langhamAuthed.vue?vue&type=style&index=0&id=2c6a1d69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a1d69",
  null
  
)

export default component.exports